/**
 * Ranked-list (directory) detection from an article's H2 headings.
 *
 * A "best X" directory is one numbered H2 per provider — "1. Indexed",
 * "2. Some Agency". Rendering treats those differently from prose articles:
 * the auto "Key Takeaways" box takes the first sentence of each H2 section,
 * which on a directory yields one positioning line per provider — filler above
 * a list that is already scannable.
 *
 * Kept here (not in BlogPost) so it stays pure and testable in the node env.
 */
export function isRankedList(h2Labels: string[]): boolean {
  return h2Labels.filter(h => /^\s*\d+[.):]\s+\S/.test(h)).length >= 3;
}
